import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../FontIcon';
import './LockOpenIcon.css';

function LockOpenIcon({ className, size, title, alt, filled, disabled }) {
  return (
    <FontIcon
      icon="unlock-alt"
      className={`lock-open-icon ${className || ''} ${size || ''}`}
      title={title}
      alt={alt}
      filled={filled}
      disabled={disabled}
    />
  );
}

LockOpenIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default LockOpenIcon;
